module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-in__body px-4 py-3"
  }, [_c('payment-method-form', {
    attrs: {
      "payments": _vm.form.payments,
      "isAmountCovered": _vm.isAmountFullyPaid,
      "showToPay": true,
      "amountReceivedDisabled": true,
      "remainingToPay": Math.max(0, _vm.amountDue - _vm.totalToPay),
      "amountDue": _vm.amountDue,
      "allowEmpty": !!_vm.editPayment
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "pay-in__separator mb-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "ml-2"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('div', {
    staticClass: "pay-in__notes-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.notes),
      expression: "form.notes"
    }],
    staticClass: "pay-in__notes-input",
    attrs: {
      "type": "text",
      "maxlength": _vm.NOTES_CHARACTER_LIMIT
    },
    domProps: {
      "value": (_vm.form.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "notes", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pay-in__notes-counter"
  }, [_vm._v("\n                " + _vm._s(_vm.form.notes.length || 0) + "/" + _vm._s(_vm.NOTES_CHARACTER_LIMIT) + "\n            ")])])]), _vm._v(" "), _c('hr', {
    staticClass: "pay-in__separator mb-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [(_vm.isNothingDue && _vm.showInvoice) ? _c('div', {
    staticClass: "pay-in__checkbox mb-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.createInvoice),
      expression: "form.createInvoice"
    }],
    attrs: {
      "type": "checkbox",
      "id": "createInvoice"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.createInvoice) ? _vm._i(_vm.form.createInvoice, null) > -1 : (_vm.form.createInvoice)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.createInvoice,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "createInvoice", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "createInvoice", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "createInvoice", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb-0 pay-in__checkbox-label",
    attrs: {
      "for": "createInvoice"
    }
  }, [_vm._v("\n                Create invoice after saving\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pay-in__checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.addBillingDetails),
      expression: "form.addBillingDetails"
    }],
    attrs: {
      "type": "checkbox",
      "id": "addBillingDetails"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.addBillingDetails) ? _vm._i(_vm.form.addBillingDetails, null) > -1 : (_vm.form.addBillingDetails)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.addBillingDetails,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "addBillingDetails", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "addBillingDetails", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "addBillingDetails", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb-0 pay-in__checkbox-label",
    attrs: {
      "for": "addBillingDetails"
    }
  }, [_vm._v("\n                Add billing details\n            ")])])]), _vm._v(" "), (_vm.form.addBillingDetails) ? _c('billing-details-form', {
    attrs: {
      "billingDetails": _vm.form.billingDetails
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center mt-5"
  }, [_c('label', {
    staticClass: "mr-2"
  }, [_vm._v("Due to Pay")]), _vm._v(" "), _c('span', {
    staticClass: "fs-large font-weight-600 mr-4"
  }, [_vm._v("\n            " + _vm._s(_vm.formatPrice(Math.max(0, _vm.amountDue - _vm.allocatedAmountReceived))) + " €\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "mr-2"
  }, [_vm._v("Total")]), _vm._v(" "), _c('span', {
    staticClass: "fs-large font-weight-600"
  }, [_vm._v("\n            " + _vm._s(_vm.formatPrice(_vm.grandTotal)) + " €\n        ")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-58e4359e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58e4359e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationPayIn/Step2Details.vue
// module id = 2004
// module chunks = 0